import React from 'react';
import styled from 'astroturf/react';

import { Button } from 'js/design_system/Button';
import { Body } from 'js/design_system/Body';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionEntity } from 'js/utils/impressions/watchImpressions';
import type { FooterImplProps } from 'js/bulk_download/WorkCardsBulkDownloadUpsellModal/DefaultModalFooter';

export function MinimalStickyFooter({
  isPremium,
  hideSecondaryAction,
  onSecondaryAction,
  onClose,
  secondaryActionLabel,
  onPrimaryCtaClicked,
  primaryCtaLabel,
  primaryCtaImpressionSource,
  sourceWorkId,
  modalVariant,
  transactionalPricingBucket,
}: FooterImplProps) {
  const handleSecondary = onSecondaryAction ?? onClose;
  const renderedSecondaryLabel =
    secondaryActionLabel ?? "No thanks, I'll stay on the free tier";
  const ctaImpressionExtra = {
    modalVariant,
    is_premium: isPremium,
    ...(transactionalPricingBucket !== undefined && {
      transactional_pricing_bucket: transactionalPricingBucket,
    }),
  };

  return (
    <StickyBar>
      <ImpressionWatcher
        source={primaryCtaImpressionSource}
        entity_type={ImpressionEntity.Work}
        entity_id={sourceWorkId}
        extra={ctaImpressionExtra}
      >
        <BarContent>
          <Button
            size="sm"
            iconRight={isPremium ? 'download' : 'arrow_forward'}
            onClick={onPrimaryCtaClicked}
          >
            {primaryCtaLabel}
          </Button>
          {!hideSecondaryAction && (
            <DismissLink type="button" onClick={handleSecondary}>
              <Body size="xs" as="span">
                {renderedSecondaryLabel}
              </Body>
            </DismissLink>
          )}
        </BarContent>
      </ImpressionWatcher>
    </StickyBar>
  );
}

const StickyBar = styled.div`
  position: sticky;
  bottom: 0;
  border-top: 1px solid var(--brand-colors-neutral-400, #dddde2);
  background: var(--background-white, #ffffff);
  padding: var(--spacing-xs-12, 12px) var(--spacing-sm-24, 24px);
`;

const BarContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm-24, 24px);
`;

const DismissLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary, #535366);
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;
